import { createStore, applyMiddleware } from "redux";
import { logger } from "redux-logger";
import thunk from "redux-thunk";
import { reducer } from "./reducers";

const middleware = [logger, thunk];

const getStore = (preloadedState = {}, siteInfoFn) => {
  const siteConfig = siteInfoFn();
  if (siteConfig.env === "prod") {
    middleware = [thunk];
  }

  const store = createStore(
    reducer.bind(siteConfig),
    preloadedState,
    applyMiddleware(...middleware),
  );

  return store;
};

export { getStore };

